import Image from 'next/image';
import { Body3 } from 'components/Typography';
import { getTokenIconUrl } from 'utils/url';
import { TokenImage } from 'components/TokenImage';

interface Token {
  iconSrc: string;
  symbol: string;
}

interface VaultTokensProps {
  tokenList: Token[];
  contributionTokenSymbol: string;
}

export const VaultTokens = (props: VaultTokensProps) => {
  const { tokenList, contributionTokenSymbol } = props;

  const visibleTokens = tokenList.slice(0, 3);
  const remainingCount = tokenList.length - 3;

  return (
    <div className='flex flex-row items-center'>
      <Image
        alt='vault tokens'
        src={getTokenIconUrl(contributionTokenSymbol)}
        width='24'
        height='24'
      />
      <Body3>+ contribution</Body3>
      <div className='flex flex-row items-center justify-center'>
        {visibleTokens.map((token, index) => (
          <div
            key={index}
            className='-mr-[8px] h-4 w-4 rounded-full bg-[#1b1b1e]'
          >
            <TokenImage
              symbol={token.symbol}
              width={16}
              height={16}
              src={token.iconSrc}
              alt={token.symbol}
            />
          </div>
        ))}
        {remainingCount > 0 && (
          <div className='ml-3 items-center justify-center rounded-full bg-[#1b1b1e] text-xs text-white'>
            +{remainingCount}
          </div>
        )}
      </div>
    </div>
  );
};
